var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaymentCardLogo = function SvgPaymentCardLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 143,
    fill: "none",
    viewBox: "0 0 247 143",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint0_linear_7693_28497)",
    strokeLinejoin: "round",
    strokeOpacity: 0.9,
    d: "m145.625 139.233 81.944-82.146a2.37 2.37 0 0 1 3.719.469l43.944 74.406a11.7 11.7 0 0 0 13.098 5.349c5.922-1.587 9.614-7.476 8.459-13.496l-16.084-83.82a28.48 28.48 0 0 0-20.606-22.145 28.5 28.5 0 0 0-24.413 4.684c-1.161.866-2.844.663-3.711-.498a52.67 52.67 0 0 0-28.587-19.377c-17.515-4.691-38.074.777-51.013 13.748L70.431 98.553a2.37 2.37 0 0 1-3.719-.469L22.768 23.678A11.7 11.7 0 0 0 9.67 18.33C3.748 19.915.056 25.805 1.211 31.825l16.084 83.82A28.48 28.48 0 0 0 37.9 137.79a28.5 28.5 0 0 0 24.413-4.684c1.161-.867 2.844-.663 3.71.498a52.68 52.68 0 0 0 28.588 19.377c19.507 5.225 37.106.194 51.013-13.748Zm-66.103-22.951a2.37 2.37 0 0 0-.363 2.878l.056.094a33.7 33.7 0 0 0 20.304 15.419 33.72 33.72 0 0 0 32.596-8.756l86.363-86.56a2.37 2.37 0 0 0 .363-2.877l-.056-.094a33.719 33.719 0 0 0-52.9-6.663zm188.192-43.379c.501 2.61-3.017 3.94-4.369 1.651l-18.851-31.92c-.549-.93-.4-2.113.363-2.877l1.121-1.124a9.531 9.531 0 0 1 16.107 4.932zM30.286 82.737c-.5-2.61 3.017-3.94 4.369-1.651l18.851 31.919c.55.93.4 2.113-.362 2.878l-1.122 1.124a9.533 9.533 0 0 1-16.107-4.932z",
    clipRule: "evenodd",
    opacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7693_28497",
    x1: 149,
    x2: 149,
    y1: 7,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#412C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F1A84E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#412C12"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentCardLogo);
export default ForwardRef;